import type { TI_DataTabData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTIDataTabData: Omit<TI_DataTabData, 'selectedVariable'> = {
  title: 'Default Data Tab Title'
};
